export const REACT_QUERY_KEYS = {
  USERS: 'users',
  PARTNERS: 'partners',
  DCS: 'dcs',
  TOURS: 'tours',
  SITES: 'sites',
  MONTHLY_TOUR_REPORTS: 'monthlyTourReports',
  CONFIG: 'config',
  TRUCK: 'truck',
  TRUCK_GROUPS: 'truckGroups',
  CUSTOMERS: 'customers',
  SHIPMENT_CATEGORIES: 'shipmentCategories',
  VEHICLE_DISPATCH_BOARDS: 'vehicleDispatchBoards',
  DRIVER_USERS: 'driverUsers',
  PACKAGE_CATEGORIES: 'packageCategories',
  MONTHLY_CUSTOMER_REPORTS: 'monthlyCustomerReports',
  ADDITIONAL_PAYMENT_CATEGORIES: 'additionalPaymentCategories',
  TAX_CATEGORIES: 'taxCategories',
  ITEM_UNITS: 'itemUnits',
  CONTRACT: 'contracts',
  SUB_PARTNERS: 'subPartners',
  SHIPMENT_ORDER_HISTORIES: 'shipmentOrderHistories',
  SHIPMENT_ORDERS: 'shipmentOrders',
  TENANTS: 'tenants',
  TRUCK_MODELS: 'trukModels',
  CHARGE_TYPES: 'chargeTypes',
  TARIFFS: 'tariffs',
  CUSTOM_KEY_SETTINGS: 'customKeySettings',
  SHIPMENT_ORDER_IMPORT_FORMATS: 'shipmentOrderImportFormats'
} as const
